export function getDefaultReplyToEmail(settings, user) {
    if (settings.transaction_email_reply_to_user)
        return user?.email || undefined;
    return settings?.transaction_email_reply_to || undefined;
}
